import { createPortal } from 'react-dom';
import './CustomModal.scss';

export enum ETitleWithOption {
  'Confirmation' = 'Confirmation',
  'Information' = 'Information',
  'Error' = 'Error',
  'Warning' = 'Warning',
  'Redirected' = 'Redirected to External Site',
}
interface ICustomModalProps {
  isModalOpen: boolean;
  title?: string;
  titleIcon?: string;
  message_header?: string;
  message_content?: string;
  message?: string;
  buttons?: any;
  contentAlignment?: string;
  contentScroll?: string;
  test?: string;
  modalContentHeight?: boolean;
  size?: string;
  additionalCssClass?: string;
  backdropDismiss?: boolean;
  footer?: any;
  extraContent?: any;
  closeBtn?: boolean;
  closeModalAction?: any;
  children?: any;
  footerAlignment?: any;
  additionalTitleOptions?: any;
}
const CustomModal = (props: ICustomModalProps) => {
  const {
    isModalOpen,
    title,
    titleIcon,
    additionalTitleOptions = null,
    message_header,
    message_content,
    message,
    buttons,
    contentAlignment = 'center',
    contentScroll = 'allow',
    modalContentHeight,
    additionalCssClass,
    backdropDismiss = false,
    footer,
    extraContent,
    size,
    closeBtn = false,
    closeModalAction,
  } = props;

  if (!isModalOpen) return null;

  return createPortal(
    <div className="Custom_Modal">
      <div className="backdrop" onClick={() => backdropDismiss && closeModalAction()} />
      <div className={`Content_Grid ${size || ''} ${additionalCssClass || ''}`}>
        {closeBtn && (
          <button className="close_btn" onClick={closeModalAction}>
            X
          </button>
        )}
        {title && (
          <div className="modal-heading">
            <div className="modal-heading-left"></div>
            <div className="modal-heading-center">
              {titleIcon && <img src={titleIcon} alt={titleIcon} className="modal-heading-icon" />}
              <h3 className="modal-heading-content"> {title}</h3>
            </div>
            <div className="modal-heading-right">
              {additionalTitleOptions && (
                // <div
                //   className="modal-heading-additional-content"
                //   dangerouslySetInnerHTML={{ __html: additionalTitleOptions }}
                // ></div>
                <div className="modal-heading-additional-content">{additionalTitleOptions}</div>
              )}
            </div>
          </div>
        )}
        <div>
          {(message_header || message_content) && (
            <div className={`modal-content ${contentAlignment || ''} ${contentScroll || 'allow'}`}>
              <h5>{message_header}</h5>
              <h6>{message_content}</h6>
              {extraContent && <div dangerouslySetInnerHTML={{ __html: extraContent }}></div>}
            </div>
          )}
          {message && (
            <div className={`modal-content ${contentAlignment || ''} ${contentScroll || 'allow'}`}>
              <div dangerouslySetInnerHTML={{ __html: message }} />
            </div>
          )}
        </div>
        {props.children && (
          <div
            className={`modal-content ${contentAlignment || ''} ${contentScroll || 'allow'} ${
              modalContentHeight ? 'height' : ''
            }`}
          >
            {props.children}
          </div>
        )}

        <div className={`action-button-container ${footer ? 'footerVisible' : ''}`}>
          {buttons?.map((button: any, index: number) => (
            <button
              key={`${button.title}_${index}`}
              disabled={button?.isDisabled ? button.isDisabled : false}
              className={`${
                button.type !== '' && button.type !== undefined && button.type !== null
                  ? button.type
                  : ''
              }`}
              onClick={button.onClick}
              data-test={button['data-test-id'] || button.type}
            >
              {button.title}
            </button>
          ))}
        </div>
        {footer && <div className={`footer`}>{footer}</div>}
      </div>
    </div>,
    document.getElementById('modal') as HTMLElement,
  );
};

export default CustomModal;
